import React, { useState, useRef } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import SerializableInventoryForm from './SerializableInventoryForm'
import * as components from '../../components'
import SlidingPane from 'react-sliding-pane'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch, useSelector } from 'react-redux'
import { getRights } from '../../state/rights'
import { getLists } from '../../state/lists'

export const AddNonSerializedInventoryPane = ({ title, onSubmit }) => {
  const formRef = useRef()
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const { user } = useSelector((state) => state.auth)
  const { rights } = useSelector((state) => state.userRights)
  const { serializable_inventory_item, consignment_type } = useSelector(
    (state) => state.lists
  )

  const loadData = () => {
    !rights && dispatch(getRights(user))
    !serializable_inventory_item &&
      dispatch(getLists('SERIALIZABLE_INVENTORY_ITEM'))
    !consignment_type && dispatch(getLists('CONSIGNMENT_TYPE'))
  }
  const dispatch = useDispatch()
  const createInventoryItems = (data) => {
    const payload = []
    data.inventory_items.forEach((element) => {
      let obj = { ...data }
      Object.keys(element).forEach((key) => {
        obj[key] = element[key]
      })
      payload.push(obj)
    })

    new rest.SerializableInventoryService()
      .makePostRequest(payload)
      .then((response) => {
        onSubmit()
        dispatch(showSuccessToast('Success', 'Non Serialized items added'))
      })
      .catch((errors) => {
        console.log(errors)
        dispatch(
          showErrorToast(
            'Error',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }

  return (
    <>
      <ReactBootstrap.Button
        variant="dark"
        size="sm"
        onClick={() => setIsPaneOpen(true)}
      >
        {components.ICONS.PLUS}
      </ReactBootstrap.Button>

      <SlidingPane
        overlayClassName="on-top"
        isOpen={isPaneOpen}
        title={title}
        onAfterOpen={loadData}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        <SerializableInventoryForm
          ref={formRef}
          rights={rights}
          serializable_inventory_item={serializable_inventory_item}
          consignment_type={consignment_type}
          onSubmit={createInventoryItems}
          enableBulkMode={true}
        />
      </SlidingPane>
    </>
  )
}
